export const SET_LOCALE = 'SET_LOCALE';
export const SET_AVAILABLE_TRANSLATION = 'SET_AVAILABLE_TRANSLATION';
export const CLEAR_AVAILABLE_TRANSLATION = 'CLEAR_AVAILABLE_TRANSLATION';
export const SET_FORMAT_LOCALE = 'SET_FORMAT_LOCALE';
